import React from 'react'
import ReactDOM from 'react-dom'
import Root from './Root'

import './load-config'

import './index.css'
import './utils.css'

import './i18n';

window.kioskApp = {}

ReactDOM.render(<Root />, document.getElementById('root'))